import React from "react";

export default function header(props) {
  return (
    <div>
      <div className="alert alert-success" role="alert">
        <h4 className="alert-heading text-center">
          Welcome todo list using React js!
        </h4>
        <hr />
      </div>
    </div>
  );
}
